import { FC, JSX } from "react";
import { Spinner } from "@radix-ui/themes";
import { useSingleBrand } from "../../hooks/useSingleBrand";
import BrandSingleUI from "./brand.single.ui";

interface BrandSingleFetcherProps {
  slug: string;
}

const BrandSingleFetcher: FC<BrandSingleFetcherProps> = ({
  slug,
}): JSX.Element | null => {
  const { data, loading, error } = useSingleBrand(slug);

  if (loading) return <Spinner />;

  if (error) {
    return <>Error: {error.message}</>;
  }

  if (data) {
    return <BrandSingleUI {...data} />;
  }
  return null;
};

export default BrandSingleFetcher;
